<template>
  <router-view />
</template>

<script>
export default {
  name: "MimamoriComponent",
};
</script>

<style></style>
